import { render, staticRenderFns } from "./CollapseMenu.vue?vue&type=template&id=caac94c2&scoped=true&"
import script from "./CollapseMenu.vue?vue&type=script&lang=js&"
export * from "./CollapseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollapseMenu.vue?vue&type=style&index=0&id=caac94c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caac94c2",
  null
  
)

export default component.exports